import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const deviceStatsSchema = z.object({
  deviceId: z.string(),
  currentDataVersion: z.string().nullable(),
  epochDate: coercedDate,
  lastAddress: z.string().nullable(),
  latitude: z.number(),
  longitude: z.number(),
  lastStoredTimeStamp: coercedDate,
});

export type DeviceStats = z.infer<typeof deviceStatsSchema>;
